import { render } from "./MessageCalendarPage.vue?vue&type=template&id=66a3c810"
import script from "./MessageCalendarPage.vue?vue&type=script&lang=js"
export * from "./MessageCalendarPage.vue?vue&type=script&lang=js"

import "./MessageCalendarPage.vue?vue&type=style&index=0&id=66a3c810&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__